<template>
    <!--
            作者：luoyiming
            时间：2019-10-24
            描述：统计-销售统计-商品统计-已付款商品
        -->
    <div class="ww100 mt30">
      <div class="common-form">订单统计</div>
      <el-tabs>
        <el-tab-pane label="所有订单统计" name="first"></el-tab-pane>
      </el-tabs>
      <div class="d-b-c">
        <div>
          <el-date-picker
            size="small"
            v-model="datePicker1"
            type="daterange"
            align="right"
            unlink-panels
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="changeDate1"
            :picker-options="pickerOptions1"
          ></el-date-picker>
        </div>
      </div>
      <div class="">
        <div class="Echarts"><div id="YMLineChart"></div></div>
      </div>
    </div>
  </template>
  
  <script>
  import StatisticsApi from '@/api/statistics.js';
  import { formatDate } from '@/utils/DateTime.js'
  export default {
    data() {
      let endDate=new Date();
      let startDate=new Date();
      startDate.setTime(startDate.getTime()- 3600 * 1000 * 24 * 7);
      return {
        /*时间快捷选项*/
        pickerOptions1: {
          shortcuts: [
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
              }
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
              }
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit('pick', [start, end]);
              }
            }
          ]
        },
        datePicker1: [formatDate(startDate,'yyyy-MM-dd'),formatDate(endDate,'yyyy-MM-dd')],
        /*数据对象*/
        dataList1: null,
        /*交易统计图表对象*/
        myChart1: null,
        /*图表数据*/
        option1: {
          title: {
            //text: 'ECharts 入门示例'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          tooltip: {
            trigger: 'axis'
          },
          yAxis: {}
        }
      };
    },
    mounted() {
      this.myEcharts1();
    },
    methods: {
  
      /*选择时间*/
      changeDate1() {
        this.getData1();
      },
  
      myEcharts1() {
        // 基于准备好的dom，初始化echarts实例
        this.myChart1 = this.$echarts.init(document.getElementById('YMLineChart'));
        /*获取列表*/
        this.getData1();
      },
  
      /*格式数据*/
      createOption1() {
        if (!this.loading) {
          let names = [];
          let xAxis = this.dataList1.days;
          let series1 = [];
          this.dataList1.data.forEach(item => {
            series1.push(item.total_num);
          });
          names = [ '总订单'];
  
          // 指定图表的配置项和数据
          this.option1.xAxis = {
            type: 'category',
            boundaryGap: false,
            data: xAxis
          };
          this.option1.color=["red", "#409EFF"];
  
          /* this.option.legend = {
            data: [{ name: names[0], color: '#ccc' }]
          }; */
          this.option1.series = [
            {
              name: names[0],
              type: 'line',
              data: series1,
              lineStyle: {
                color: 'red'
              }
            }
          ];
  
          this.myChart1.setOption(this.option1);
          this.myChart1.resize();
        }
      },
  
      /*获取列表*/
      getData1() {
        let self = this;
        self.loading = true;
        StatisticsApi.getAllorder(
          {
            search_time: self.datePicker1
          },
          true
        )
          .then(res => {
            self.dataList1 = res.data;
            self.loading = false;
            self.createOption1();
            console.log("所有订单统计",res.data);
          })
          .catch(error => {});
      }
    }
  };
  </script>
  
  <style scoped="scoped">
    .Echarts{ box-sizing: border-box;}
    .Echarts>div{ width: 100%; height: 360px; box-sizing: border-box;}
  </style>
  


// WEBPACK FOOTER //
// src/views/statistics/sales/part/OrderStatistics.vue